import PropTypes from "prop-types";
import styleModule from "./GeneralButton.module.sass";

const GeneralButton = props => {
  const { element, onClick, type, disabled, className, children, submit, id, style } =
    props;
  return (
    <button
      className={`${
        type ? styleModule[type] : styleModule.default
      } ${className} `}
      onClick={onClick}
      disabled={disabled}
      type={submit && "submit"}
			style={style}
      id={id}
    >
      {children}
      {element}
    </button>
  );
};

GeneralButton.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
    PropTypes.array
  ]),
  onClick: PropTypes.func,
  type: PropTypes.oneOf([
    "primary",
    "primary-invert",
    "secundary",
    "secundary-invert"
  ]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
    PropTypes.array
  ]),
  submit: PropTypes.bool
};

export default GeneralButton;
